/**
 * Single Room Carousel Component
 * Simple Flickity carousel for single room gallery section
 */

import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';

export default class SingleRoomCarousel {
  constructor(element) {
    this.element = element;
    this.carousel = element.querySelector('[data-single-room-carousel]');
    this.prevBtn = element.querySelector('.single-room-gallery__carousel-prev');
    this.nextBtn = element.querySelector('.single-room-gallery__carousel-next');
    this.counter = element.querySelector('.single-room-gallery__carousel-counter');
    this.caption = element.querySelector('.single-room-gallery__carousel-caption');
    
    this.flickity = null;
    this.images = [];
    
    this.init();
  }

  init() {
    if (!this.carousel) return;

    // Collect image data
    const slides = this.carousel.querySelectorAll('[data-image-id]');
    this.images = Array.from(slides).map((slide) => ({
      id: slide.getAttribute('data-image-id'),
      caption: slide.getAttribute('data-caption') || '',
    }));

    // Initialize Flickity
    this.flickity = new Flickity(this.carousel, {
      cellAlign: 'center',
      contain: false,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      imagesLoaded: true,
      percentPosition: false,
      cellSelector: '.single-room-gallery__carousel-slide',
    });

    // Bind custom controls
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.flickity.previous();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.flickity.next();
      });
    }

    // Update counter and caption on change
    this.flickity.on('change', (index) => {
      this.updateCounter(index);
      this.updateCaption(index);
    });

    // Initialize counter
    this.updateCounter(0);
    this.updateCaption(0);
  }

  updateCounter(index) {
    if (this.counter && this.images.length > 0) {
      console.log(this.counter);
      console.log(this.counter.html);
      this.counter.innerHTML = "<span>" + `${index + 1}` + "</span> of <span>" + `${this.images.length}` + "</span>";
    }
  }

  updateCaption(index) {
    if (this.caption && this.images[index]?.caption) {
      this.caption.textContent = this.images[index].caption;
    }
  }
}
